import styled from 'styled-components';
import {
  darken,
  lighten,
} from 'polished';
import {
  Flex,
  SVG,
  icons,
} from 'web-styled';
import {
  Link,
} from 'react-router';

const darked = props => darken(0.05, props.theme.colors.primary);

export const Header = styled(Flex)`
  background: ${props => props.theme.colors.bgBlack};
  width: 100%;
  flex: 0 0 64px;

  @media print {
    display: none;
  }
`;

export const Search = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  background: #2f3538;
  padding: 16px 12px;
  white-space: nowrap;
  width: 100%;
  position: relative;
`;

export const InputGroup = styled(Flex).attrs({
  align: 'center',
})`
  width: 100%;
`;

export const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  height: 32px;
  border-radius: 50px 0 0 50px;
  background: #FAFAFA;
  padding: 6px 12px;
  color: #707070;
  font-size: 14px;
  line-height: 1.42857143;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
  box-sizing: border-box;

  &::placeholder {
    color: #707070;
    opacity: 1;
  }

  &:focus,
  &:active {
    color: #707070;
    box-shadow: none;
  }
`;

export const SearchButton = styled.button`
  color: #707070;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  height: 32px;
  padding: 7px 12px;
  margin-bottom: 0;
  border: none;
  outline: none;
  border-radius: 0 50px 50px 0;
  background: #FAFAFA;
  cursor: pointer;
`;

export const SearchDropdown = styled.div`
  position: absolute;
  top: calc(100% - 10px);
  left: 12px;
  right: 12px;
  max-height: 420px;
  overflow-y: auto;
  padding: 8px 0 10px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);
  z-index: 1000;
`;

export const SearchCategory = styled.div`
  & + & {
    border-top: 1px solid #eef1f2;
    margin-top: 4px;
    padding-top: 4px;
  }
`;

export const SearchCategoryTitle = styled.div`
  padding: 10px 16px 6px;
  color: #7f8a8f;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const SearchResultLink = styled(Link)<{ $isActive?: boolean }>`
  display: block;
  padding: 10px 16px;
  color: #243033;
  text-decoration: none;
  background: ${props => (props.$isActive ? lighten(0.3, props.theme.colors.primary) : 'transparent')};

  &:hover {
    background: ${props => lighten(0.3, props.theme.colors.primary)};
  }
`;

export const SearchResultName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 20px;
`;

export const ViewAllButton = styled.button`
  width: calc(100% - 32px);
  margin: 10px 16px 0;
  padding: 10px 14px;
  border: 0;
  border-radius: 999px;
  color: #ffffff;
  background: ${props => props.theme.colors.primary};
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  text-align: center;

  &:hover {
    background: ${darked};
  }
`;

export const SearchEmpty = styled.div`
  padding: 18px 16px 14px;
  color: #7f8a8f;
  font-size: 13px;
`;

export const Dropdown = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  position: relative;
  width: ${props => props.width || '64px'};
  height: 64px;
  background: ${props => (props.isOpen ? darked(props) : '#23292b')};
`;

export const Trigger = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  color: ${props => (props.isOpen ? '#fff' : '#a6a9aa')};
  height: 46px;
  cursor: pointer;
`;

export const Avatar = styled.div`
  height: 42px;
  width: 42px;
  border-radius: 50%;
  cursor: pointer;
  background-size: contain;
  background-color: ${props => props.theme.colors.primary};
  background-image: url(${props => props.avatar || icons.clientAvatarWhitePlaceHolder});
  background-repeat: no-repeat;
  background-position: center center;
  border: 2px solid #fff;
  user-select: none;
`;

export const Actions = styled.div`
  min-width: ${props => props.minWidth || '160px'};
  padding: 14px 0;
  margin-top: 9px;
  margin-right: ${props => props.mr || 0}px;
  background: ${darked};
  z-index: 999;
  box-sizing: border-box;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
`;

export const Action = styled(Flex).attrs({
  spacing: 10,
  padding: '0 15px',
})`
  color: #fff;
  font-size: 12px;
  height: 39px;
  line-height: 39px;
  cursor: pointer;

  &:hover {
    background: ${props => darken(0.07, props.theme.colors.primary)};

    span {
      opacity: 1;
    }
  }
`;

export const ActionIcon = styled.span`
  height: 22px;
  width: 20px;
  opacity: 0.65;
  position: relative;
  top: 7px;
  left: 7px;
  background-repeat: no-repeat;
  ${(props) => {
    switch (props.icon) {
      case 'payment':
        return `
          background-size: contain;
          background-position: center;
        `;
      case 'referral':
        return `
          background-size: 100% 100%;
        `;
      case 'signout':
        return `
          background-size: 14px;
          background-position: center;
        `;
      default:
        return `
          background-size: cover;
          background-position: left top;
        `;
    }
  }}
`;

export const SVGIcon = styled.span`
  position: relative;
  left: 0px;
  top: 4px;
  opacity: 0.65;

  svg {
    height: 18px !important;
    width: 16px !important;
  }
`;

export const PlusCircle = styled(SVG.PlusCircle).attrs(
  props => ({
    stroke: '#ffffff',
    width: '19px',
    height: '23px',
    fill: props.isOpen ? 'none' : props.theme.colors.success,
  }),
)``;

export const HelpIcon = styled.div`
  width: 21px;
  height: 23px;
  opacity: ${props => (props.isOpen ? 1 : 0.8)};
  background-size: cover;
  background-image: url(${icons.sidebarHelp});
`;
